import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { useAddNotification } from "hooks";

import { useRequest } from "../../../../hooks/useRequest";
import * as requestUrl from "../../../../constants/request";
import { renderConditionalProp } from "../../../../utility/utils";

import { SidePageWrapper } from "../../../layout/sidePageWrapper/SidePageWrapper";

import classes from "./Verification.module.scss";

export const Verification = () => {
  // Prepare the necessary variables/etc that are needed
  const { t } = useTranslation(["account", "common"]);
  const [mailSent, setMailSent] = useState(false);
  const { request } = useRequest();
  const [searchParams] = useSearchParams();
  const addNotification = useAddNotification();

  const resendEmail = () => {
    const sessionToken = searchParams.get("session_token") || "";
    if (!!sessionToken) {
      request(requestUrl.FT_USERS_VERIFICATION, {
        data: sessionToken,
        headers: {
          "content-type": "text/plain",
        },
        method: "POST",
      })
        .then((response: any) => {
          setMailSent(true);
          addNotification({
            messages: ["email_sent"],
            type: "SUCCESS",
            closable: true,
          });
        })
        .catch((err) => {
          addNotification({
            messages: ["something_went_wrong"],
            type: "ERROR",
            closable: true,
          });
        });
    }
  };

  return (
    <SidePageWrapper small={true} hideDisclaime={true} hideBannerWidget={true}>
      <div className={classes.CenteringContainer}>
        <div className={classes.Container}>
          <div className={classes.Icon_wrapper}>
            <ft-icon>mail_outline</ft-icon>
          </div>
          <div className={classes.Details}>
            <p className={classes.Details_heading}>
              {t("account:verify_account")}
            </p>
            <div className={classes.Details_text}>
              <p>{t("account:account_verify_text1")}</p>
              <p>{t("account:account_verify_text2")}</p>
            </div>
          </div>
          <div className={classes.Button_wrapper}>
            <ft-button
              {...renderConditionalProp(mailSent, "disabled")}
              onClick={resendEmail}
              unelevated
              label={t("account:resend_email")}
            ></ft-button>
          </div>
        </div>
      </div>
    </SidePageWrapper>
  );
};
